export default "__VITE_ASSET__9419e191__"